import { Outlet } from 'react-router-dom';
import { useAuthInit, useKeyboardShortcuts } from '../hooks';
import { useSocket } from '../hooks/useSocket';

export function RootLayout() {
  useAuthInit();
  useSocket();
  useKeyboardShortcuts();

  return (
    <div className="app-root">
      <Outlet />
    </div>
  );
}
